import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {IFailedRefund} from "../interfaces/IFailedRefund";
import {APIService} from "./api.service";

@Injectable({
  providedIn: 'root'
})
export class FailedRefundService {

  private apiService: APIService = inject(APIService);

  getAllFailedRefunds(): Observable<IFailedRefund[]> {
    return this.apiService.MakeGetRequest<IFailedRefund[]>('failed-refund/all');
  }
}
